

function Card(props) {

    return (
        <div className="adv-card"  style={{backgroundColor:"#235756", minHeight:"250px"}}>
            <h4>{props.info.title}</h4>
            <p className="card-text">{props.info.text}</p>
        </div>
    )
}

export default Card